import React, { useCallback, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import darajaLogoBlack from "@/assets/images/darajaLogoBlack.svg";
import MastercardLogo from "@/assets/images/MastercardLogo.svg";

import { useAuth } from "../hooks/useAuth";

const Login: React.FC = () => {
  const { status, login } = useAuth();
  const location = useLocation();

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [mastercardLoaded, setMastercardLoaded] = useState(false);
const [darajaLoaded, setDarajaLoaded] = useState(false);

  const from =
    (location.state as { from?: { pathname?: string } })?.from?.pathname ||
    "/dashboard";

  useEffect(() => {
    document.title = "Sign in | Daraja Platform";
    sessionStorage.removeItem("tour_started");
  }, []);

  const handleLogin = useCallback(async () => {
    if (isLoading) return;

    setError("");
    setIsLoading(true);

    try {
      await login();
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : "Login failed");
    } finally {
      setIsLoading(false);
    }
  }, [login, isLoading]);

  if (status === "signedIn") {
    return <Navigate to={from} replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200">
      <div className="w-full max-w-sm bg-gray-100 border border-gray-300 rounded-xl p-8 text-center">
        {/* Mastercard Logo */}
        {/* Mastercard Logo */}
<div className="flex justify-center mb-4 h-8">
  {!mastercardLoaded && (
    <div className="h-8 w-36 rounded bg-gray-300 animate-pulse" />
  )}

  <img
    src={MastercardLogo}
    alt="Mastercard Foundation"
    loading="eager"
    fetchPriority="high"
    onLoad={() => setMastercardLoaded(true)}
    className={`h-8 transition-opacity duration-300 ${mastercardLoaded ? "opacity-100" : "opacity-0"}`}
  />
</div>

        {/* Title */}
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">
          Sign in
        </h2>

        {/* Selected Option */}
        <div className="border-2 border-[var(--color-brand)] rounded-lg px-4 py-3 flex items-center gap-2 mb-6">
          <div className="h-3 w-3 rounded-full border-2 border-[var(--color-brand)] flex items-center justify-center">
            <div className="h-1.5 w-1.5 bg-[var(--color-brand)] rounded-full" />
          </div>

          <span className="text-gray-700 font-medium">
            Daraja Platform
          </span>
        </div>

        {/* Login Button */}
        <button
          onClick={handleLogin}
          disabled={isLoading}
          className="
            w-full
            bg-[var(--color-brand)]
            hover:bg-[#A63F00]
            disabled:opacity-70
            disabled:cursor-not-allowed
            text-white
            py-2.5
            rounded-lg
            font-semibold
            transition
            focus:outline-none
            focus-visible:ring-4
            focus-visible:ring-slate-600
            focus-visible:ring-offset-2
          "
        >
          {isLoading ? "Signing in..." : "Login"}
        </button>

        {error && (
          <div className="text-red-600 text-sm mt-3">
            {error}
          </div>
        )}

        <hr
          className="my-6 border-gray-300"
          aria-hidden="true"
        />

        {/* Daraja Logo */}
<div className="flex justify-center h-8">
  {!darajaLoaded && (
    <div className="h-8 w-28 rounded bg-gray-300 animate-pulse" />
  )}

  <img
    src={darajaLogoBlack}
    alt="Daraja Logo"
    loading="eager"
    fetchPriority="high"
    onLoad={() => setDarajaLoaded(true)}
    className={`h-8 transition-opacity duration-300 ${darajaLoaded ? "opacity-100" : "opacity-0"}`}
  />
</div>
      </div>
    </div>
  );
};

export default Login;